import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import "./../../assets/styles/Style.css";
import Cropic from '../../assets/images/1.png';
import Nfsm from '../../assets/images/5.png';
import NaturalFarming from '../../assets/images/2.png';
import SeedProduction from '../../assets/images/6.svg';
import { Link, Navigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserAlt, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import CDPLogo from '../../assets/images/cdp1.png';

let menuCodeData = [];
const AccessNew = () => {
    const { state } = useLocation()
    let [userRoleCodeArray, setUserRoleCodeArray] = useState([]);
    const [totalScheme, setTotalScheme] = useState([])
    let schemeNames = ["Pradhan Mantri Fasal Bima Yojana", "Natural Farming", "National Food Security Mission", "Seed Production", "Common-For Admin Testing", "Digital Crop Survey"];
    let schemeImages = ["../../assets/images/1.png", '../../assets/images/2.png', "", "", '../../assets/images/5.png', '../../assets/images/6.png', ""]


    useEffect(() => {
        if (localStorage.getItem("userRoleCode").includes(",")) {
            setUserRoleCodeArray(localStorage.getItem("userRoleCode").split(","))
        }
        setTotalScheme(localStorage.getItem("schemeCode").split(","));
    }, [])

    const navigate = useNavigate();
    function capitalFirstLetter(string) {
        return string
        // return string.charAt(0).toUpperCase() + string.slice(1);
    }

    function handleMenu(localCount, localIndex) {

        localStorage.setItem("schemeCodeSingle", localCount);
        let localUserRoleCode = [];


        axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Menu/getMenubyRoleSchemesCode`, {
            // "roleCode": localUserRoleCode[localIndex],
            "roleCode": localStorage.getItem("userRoleCode").includes(",") ? localStorage.getItem("userRoleCode").split(",")[localIndex] : localStorage.getItem("userRoleCode"),
            "schemeCode": localCount
        })
            .then(function (response) {
                menuCodeData = response.data.dataContent;
                localStorage.setItem("menuCodeData", JSON.stringify(menuCodeData));
                let navRoute;
                if (Number(localCount) === 1) {
                    navigate("/Cropic/dashboard")

                } else if (Number(localCount) === 2) {
                    navigate("/nature/dashboard")

                } else if (Number(localCount) === 3) {
                    navigate("/nfsm/dashboard")

                } else {
                    alert("This scheme is under development")

                }

            })
            .catch(function (error) {
                console.log(error);
            });

    }
    return (
        <>
            <main className="mainLogin d-flex align-items-center justify-content-center">
                {/* <div className="btn-group logoutPosition">
                    <button className="btn btn-success dropdown-toggle" type="button" id="defaultDropdown" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                        <FontAwesomeIcon icon={faUserCircle} /> {capitalFirstLetter(localStorage.getItem("username"))}
                    </button>
                    <ul className="dropdown-menu" aria-labelledby="defaultDropdown">
                        <li className="dropdown-header"><h6>{capitalFirstLetter(localStorage.getItem("username"))}</h6></li>
                        <li><hr className="dropdown-divider" /></li>
                        <li><Link className="dropdown-item d-flex text-center signout" to="/" onClick={() => { sessionStorage.removeItem("user") }}><span>Sign Out </span></Link></li>
                    </ul>
                </div> */}




<div className="container accessBoxes">
    <div className="mb-5">

        <h1 className="text-center text-capitalize text-success">Welcome to Krishi MApper,</h1>
        <h3 className="text-center text-capitalize text-success">choose scheme below to go further</h3>
    </div>
    <div className="row justify-content-center accessBox">

   
        
        <div className="col-md-3">
            <Link to="/Nature/dashboard" className="card NFSMLogo" onClick={() => handleMenu(2)}>
                <img src={NaturalFarming} className="img-fluid" />
                <div className="btn btn-success mb-1 mt-3 ">Nature Farming</div>
            </Link>
        </div> 
        <div className="col-md-3">
            <Link to="/Nature/dashboard" className="card NFSMLogo" onClick={() => handleMenu(2)}>
                <img src={NaturalFarming} className="img-fluid" />
                <div className="btn btn-success mb-1 mt-3 ">PDMC</div>
            </Link>
        </div> 

        {/* {totalScheme[0] === "" ? <div><h1 className="text-center text-capitalize text-danger">This User is not Associated with any Scheme</h1></div> :
            totalScheme.map((item, index) => {

                let count = Number(item) - 1;
                let imgSrc;

                if (count === 0) {
                    imgSrc = Cropic
                } else if (count === 1) {
                    imgSrc = NaturalFarming
                } else if (count === 2) {
                    imgSrc = Nfsm
                } else if (count === 3) {
                    imgSrc = NaturalFarming
                } else if (count === 4) {
                    imgSrc = NaturalFarming
                } else if (count === 5) {
                    imgSrc = ""
                }

                return (
                    <div className="col-md-3" key={index}>
                        <div className={`card ${count === 0 ? '' : 'NFSMLogo'}`} onClick={() => handleMenu(item, index)}>
                            <img src={imgSrc} className="img-fluid" />
                            <div className="btn btn-success mb-1 mt-3 ">{schemeNames[count]}</div>

                        </div>
                    </div>
                )
            })
        } */}

        {/* Below scheme is for GCES */}
        {/* <div className="col-md-3">
            <Link to="/GCES/dashboard" className="card NFSMLogo">
                <img src={Nfsm} className="img-fluid" />
               <div className="btn btn-success mb-1 mt-3 ">GCES</div>

            </Link>
        </div> */}
        {/*<div className="col-md-3">*/}
        {/*    <Link to="/Cropic/dashboard" className="card NFSMLogo">*/}
        {/*        <img src={SeedProduction} className="img-fluid" />                                        */}
        {/*        <div className="btn btn-success mb-1 mt-3 ">SEED Production</div>*/}

        {/*    </Link>*/}
        {/*</div>*/}
        {/*<div className="col-md-3">*/}
        {/*    <Link to="/Cropic/dashboard" className="card">*/}
        {/*        CCE*/}
        {/*        <div className="btn btn-success mb-1 mt-3 ">Pradhan Mantri Fasal Bima Yojana</div>*/}

        {/*    </Link>*/}
        {/*</div>*/}

        {/* <div className="col-md-3" >
            <div className= "card NFSMLogo" onClick={() => { navigate("/cdp/dashboard")}}>
                <img src={CDPLogo} className="img-fluid" />
                <div className="btn btn-success mb-1 mt-3 ">CDP</div>

            </div>
        </div>

        <div className="col-md-3" >
            <div className= "card NFSMLogo"  onClick={() => { navigate("/nhb/dashboard")}}>
                <img src={CDPLogo} className="img-fluid" />
                <div className="btn btn-success mb-1 mt-3 ">NHB</div>

            </div>
        </div> */}

    </div>
</div>


                <footer className="login footer">

                    <div className="credits">Website Content Owned & Managed by Department of Agriculture & Farmers Welfare | MoA&FW | Government of India, India<br />
                        <a href="#">Designed and Developed by: DAD/IT, Ministry of Agriculture, New Delhi, India.</a>
                    </div>
                </footer>
            </main>
        </>
    )
}







export {
    AccessNew,
    menuCodeData
}